<template>
  <div class="options-wrapper">
    <div class="cards-wrapper">
      <div
        v-for="(item, index) in data.options"
        :key="item.code"
        :class="{ active: index === activeIndex }"
        @click="onChoose(item, index)"
      >
        <div v-if="item.icon" class="card-item-wrap">
          <img class="card-img" :src="item.icon" alt="" />
          <div v-if="item.content" class="card-title">{{ item.content }}</div>
          <div
            v-if="item.description"
            class="card-desc"
            :class="{ large: !item.content }"
          >
            {{ item.description }}
          </div>
        </div>

        <div v-else class="card-item-wrap other">{{ item.content }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import Popup from '@component/Popup/';
import { IQuestion, IAnswerItem, IOption } from './types';

@Component({
  components: { Popup },
})
export default class Questionnaire extends Vue {
  @Prop({}) data!: IQuestion;
  @Prop({}) answer!: IAnswerItem;

  activeIndex: number | null = null;

  mounted() {
    if (this.data && this.answer) {
      const answerCode = this.answer.options![0].code;

      const index = this.data.options.findIndex((item: IOption) => {
        return item.code === answerCode;
      });
      if (index !== -1) {
        this.activeIndex = index;
      }
    }
  }

  onChoose(item: IOption, index: number) {
    this.activeIndex = index;
    this.$emit('onChoose', this.data, item);
  }
}
</script>

<style lang="scss" scoped vars="{ques-theme-bg, ques-theme-bg-opacity}">
$theme-color: var(--ques-theme-bg);
$theme-color-opacity: var(--ques-theme-bg-opacity);
$color-font: #382d68;

.options-wrapper {
  width: 100vw;
  padding: 0 42px;
}
.title {
  margin-bottom: 24px;
  color: #382d68;
  font-weight: bold;

  font-size: 30px;
  line-height: 42px;
  text-align: center;
}

.cards-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .card-item-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 317px;
    margin-top: 32px;
    padding: 42px 0;
    color: $color-font;
    text-align: center;
    background-color: #f5f5fb;
    border: 2px solid #f5f5fb;
    border-radius: 8px;
  }
  .active {
    .card-item-wrap {
      background-color: $theme-color-opacity;
      border-color: $theme-color;
    }
  }

  .card-img {
    width: 128px;
    height: 128px;
    margin-bottom: 24px;
  }
  .card-title {
    width: 265px;
    height: 46px;
    margin-bottom: -8px;
    font-weight: bold;
    font-size: 28px;
    line-height: 46px;
  }
  .card-desc {
    width: 265px;
    height: 80px;
    margin-top: 16px;
    overflow: scroll;
    font-size: 24px;
    line-height: 40px;

    &.large {
      margin-top: 0;
      font-size: 28px;
    }
  }
  .other {
    width: 666px;
    height: 96px;
    padding: 0 !important;
    font-size: 28px;
    line-height: 96px;
  }
}
</style>
